import { PropType, defineComponent } from "vue";
import BpmnViewer from "bpmn-js/lib/Viewer";
import * as generate from "nanoid/generate";
import { loadDefinitionDiagram } from "@/store/flow/actions";

type OverlayAction = (element: string) => any;

export default defineComponent({
  name: "sdk-flow-bpmn-viewer",
  props: {
    definitionId: {
      type: String,
      required: true,
    },
    showIncidents: Boolean,
    overlayAction: {
      type: Function as PropType<OverlayAction>,
    },
    xml: String,
  },
  data() {
    return {
      bpmnCanvasId: `bpmn-id-${generate("1234567890abcdef", 10)}`,
      bpmnViewer: {} as any,
      loading: false,
      xmlIsLoaded: false,
    };
  },
  methods: {
    mountBpmn() {
      this.bpmnViewer = new BpmnViewer({
        container: `#${this.bpmnCanvasId}`,
      });
      this.importXml();
    },
    async importXml() {
      this.loading = true;
      let xml: any = null;
      if (this.xml) {
        xml = this.xml;
      } else {
        const { bpmn20Xml } = await this.$dispatch(loadDefinitionDiagram)([{ id: this.definitionId, key: this.$route.params.definitionKey }]);
        xml = bpmn20Xml;
        this.$emit("loaded");
      }
      this.bpmnViewer.importXML(xml, async (err: any) => {
        if (!err) {
          this.fitZoom();
          this.loading = false;
          this.xmlIsLoaded = true;
        }
      });
    },
    async fitZoom() {
      const canvas = await this.bpmnViewer.get("canvas");
      canvas.zoom("fit-viewport");
    },
  },
  async mounted() {
    this.mountBpmn();

    this.$root.$on("t-menu", () => {
      /* Timeout usado para aguuardar o fim da transição do menu */
      setTimeout(() => {
        this.fitZoom();
      }, 500);
    });
  },
  beforeDestroy() {
    this.bpmnViewer.clear();
    this.$root.$off("t-menu");
  },
});
